// Currency column with positive/negative color-coding.
//
// Formats the value as USD currency and colors it green (positive)
// or red (negative). Useful for profit, margin, or balance columns.
//
// Column def:  { field: "grossProfit", behavior: "positiveNegative" }

export const positiveNegative = {
  apply() {
    return {
      valueFormatter: (params) => {
        if (params.value == null || params.value === "") return ""
        const num = parseFloat(params.value)
        if (isNaN(num)) return ""
        return num.toLocaleString("en-US", { style: "currency", currency: "USD" })
      },

      cellStyle: (params) => {
        if (params.value == null || params.node?.rowPinned) return null
        const num = parseFloat(params.value)
        if (isNaN(num)) return null
        return { color: num < 0 ? "var(--color-error)" : "var(--color-success)" }
      },

      sortable: true,
      filter: true
    }
  }
}
